import script from "./VHeroModel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VHeroModel.vue?vue&type=script&setup=true&lang=ts"

import "./VHeroModel.vue?vue&type=style&index=0&id=eb2a7884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb2a7884"]])

export default __exports__